import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from "@spartacus/core";
import { CardAction, CardComponent, CardLinkAction } from '@spartacus/storefront';
import { ICON_TYPE } from 'src/app/custom/icons/icon.model';

export interface Card {
  header?: string;
  title?: string;
  textBold?: string;
  text?: Array<string>;
  paragraphs?: Array<{ title?: string; text?: Array<string> }>;
  img?: string;
  actions?: Array<CardAction | CardLinkAction>;
  deleteMsg?: string;
}


@Component({
  selector: 'cx-card',
  templateUrl: './custom-card.component.html',
  standalone: false
})
export class CustomCardComponent extends CardComponent implements OnInit, AfterViewInit {
  @Input() shippingCards = false;
  @Input() length = false;
  @Input() showDefaultText = false;
  iconType = ICON_TYPE;
  content: Card;

  constructor(
    protected messageService: GlobalMessageService
  ) {
    super();
  }

  setDefault(): void {
    this.isDefault = true;
    this.setDefaultCard.emit(2);
    this.showGlobalMessage('addressForm.userAddressUpdateSuccess');
  }

  private showGlobalMessage(text: string): void {
    this.messageService.add(
      { key: text },
      GlobalMessageType.MSG_TYPE_CONFIRMATION
    );
  }

  ngAfterViewInit(): void {
    const shippingCards = document.querySelector('.is-default');
    const shippingButton = document.querySelector('.shipping-continue-button');
    if (shippingCards) {
      shippingButton?.classList.remove('no-default');
    } else {
      shippingButton?.classList.add('no-default');
    }
  }

}
